import React from 'react';

const COVER_ORIGIN = 'https://lmd.lemeilleurdu.digital';

const normalizeSlug = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-|-$/g, '');

const normalizeCoverUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/covers/')) return `${COVER_ORIGIN}${raw}`;
  return raw;
};

const ImageWithFallback = ({ src, alt, categorySlug, className = '' }) => {
  const safeCategory = normalizeSlug(categorySlug);
  const categoryFallback = safeCategory ? normalizeCoverUrl(`/covers/${safeCategory}.webp`) : null;
  const defaultFallback = normalizeCoverUrl('/covers/default.webp');

  const [attempt, setAttempt] = React.useState(0);
  const [currentSrc, setCurrentSrc] = React.useState(normalizeCoverUrl(src) || categoryFallback || defaultFallback);
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    setAttempt(0);
    setHidden(false);
    setCurrentSrc(normalizeCoverUrl(src) || categoryFallback || defaultFallback);
  }, [src, categoryFallback]);

  const handleError = () => {
    if (attempt === 0 && categoryFallback && currentSrc !== categoryFallback) {
      setAttempt(1);
      setCurrentSrc(categoryFallback);
      return;
    }

    if (attempt <= 1 && currentSrc !== defaultFallback) {
      setAttempt(2);
      setCurrentSrc(defaultFallback);
      return;
    }

    setAttempt(3);
    setHidden(true);
  };

  if (hidden || !currentSrc) return null;

  return <img src={currentSrc} alt={alt} className={className} onError={handleError} />;
};

export default ImageWithFallback;
